import React from "react";
import STableHeader from "./STableHeader";
import STableBody from "./STableBody";

const STable = ({ columns, sortColumn, onSort, data, ...rest }) => {
  return (
    <table className="table">
      <STableHeader columns={columns} sortColumn={sortColumn} onSort={onSort} />
      <STableBody columns={columns} data={data} {...rest} />
    </table>
  );
};

export default STable;



// WEBPACK FOOTER //
// ./src/components/Common/STable.jsx